export default function genererUtilisateur() {
  return {
    id: null,
    nom: '',
    prenom: '',
    civiliteId: '',
    email: '',
    telephone: '',
    agenceId: '',
    identifiant: '',
    motPasse: '',
    connexionAutorisee: true,
    signatureEmail: '',
    profil: '',
    roles: [],
    objetsRoles: [],
    agencesId: [],
    motPasseConf: '',
    estTechnicien: false,
    regieExterne: false,
    responsableBail: false,
    domaine: '',
    servicesId: [],
    services: [],
  };
}
